import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=30fd5962&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"
import style0 from "./commission.vue?vue&type=style&index=0&id=30fd5962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd5962",
  null
  
)

export default component.exports